import { render, staticRenderFns } from "./addEidt.vue?vue&type=template&id=0cd51c64&scoped=true&"
import script from "./addEidt.vue?vue&type=script&lang=js&"
export * from "./addEidt.vue?vue&type=script&lang=js&"
import style0 from "./addEidt.vue?vue&type=style&index=0&id=0cd51c64&scoped=true&lang=css&"
import style1 from "./addEidt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd51c64",
  null
  
)

export default component.exports